import { render, staticRenderFns } from "./UserCard.vue?vue&type=template&id=64b26b48"
import script from "../../../scripts/partials/cards/UserCard.js?vue&type=script&lang=js&external"
export * from "../../../scripts/partials/cards/UserCard.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports